import { useState, useCallback, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { Row, Card, Button, message, Form, Switch, Checkbox } from "antd";
import { Input, Select, Space } from "antd";
import axios from "axios";
import Spinner from "../components/common/Spinner/Spinner";
import CustomSwitch from "../components/common/Switch/CustomSwitch";
import { useHistory, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const options = [
  {
    label: "Mega Image",
    value: "Mega Image",
  },
  {
    label: "LSDV",
    value: "LSDV",
  },
  {
    label: "Sly Nutritia",
    value: "Sly Nutritia",
  },
  {
    label: "RER Ecologic",
    value: "RER Ecologic",
  },
  {
    label: "Grupul Tei",
    value: "Grupul Tei",
  },
  {
    label: "Orshar Logistics",
    value: "Orshar Logistics",
  },
  {
    label: "Aquila",
    value: "Aquila",
  },
  {
    label: "Quehenberger Logistics",
    value: "Quehenberger Logistics",
  },
  {
    label: "NEPI",
    value: "NEPI",
  },
  {
    label: "Professional Farmaline",
    value: "Professional Farmaline",
  },
  {
    label: "Pepco",
    value: "Pepco",
  },
  {
    label: "Electromagnetica",
    value: "Electromagnetica",
  },
  {
    label: "Other",
    value: "Other",
  },
];

const societatiPaza = [
  {
    label: "AKB SECURITY",
    value: "AKB SECURITY",
  },
  {
    label: "ELNET SECURITY",
    value: "ELNET SECURITY",
  },
  {
    label: "ORION SECURITY",
    value: "ORION SECURITY",
  },
  {
    label: "RPG SECURITY",
    value: "RPG SECURITY",
  },
  {
    label: "SSG SECURITY",
    value: "SSG SECURITY",
  },
  {
    label: "SSG FIRE&RESCUE",
    value: "SSG FIRE&RESCUE",
  },
  {
    label: "HIGHLANDER GUARD",
    value: "HIGHLANDER GUARD",
  },
];

const possibleActvityTypes = [
  {
    label: "Verificare agenti la schimbul de tura (L-V)",
  },
  {
    label: "Verificare agenti anterior armare (L-V)",
  },
  {
    label: "Verificare agenti la plecare (S-D)",
  },
  {
    label: "Verificare angajati MI la schimb de tura(L-V)",
  },
  {
    label: "Verificare angajati MI anterior armare (L-V)",
  },
  {
    label: "Verificare angajati MI la plecare (S-D)",
  },
  {
    label: "Verificari de noapte agenti /angajati MI",
  },
  {
    label: "Verificari de zi (L-V) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Verificari de zi (S-D) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Control Politie cu SO direct implicat",
  },
  {
    label: "Participare la oprire pers. suspecte de furt.",
  },
  {
    label: "Participare verificari/analizari prejudicii",
  },
  {
    label: "Raportare eveniment",
  },
  {
    label: "Patrulare/stationare echipaje mobile",
  },
  {
    label: "Solicitare telefonica sef magazin",
  },
  {
    label: "Solicitare telefonica agent securitate",
  },
  {
    label: "Solicitare telefonica CMV",
  },
  {
    label: "Preventie/activitate specifica in afara magazinului",
  },
  {
    label: "Servicii de test",
  },
  {
    label: "Control de zi",
  },
  {
    label: "Control de noapte",
  },
  {
    label: "Armare locatie",
  },
  {
    label: "Dezarmare locatie",
  },
  {
    label: "Verificare buton panica",
  },
  {
    label: "Verificare CCTV",
  },
  {
    label: "Verificare porti senzomatice",
  },
  {
    label: "Instruire personal",
  },
  {
    label: "Mentenanta semestiala",
  },
  {
    label: "Verificare coordonator",
  },
  {
    label: "Patrula",
  },
  {
    label: "Verificari angajati la schimb de tura",
  },
  {
    label: "Verificari angajati la inchidere/plecare",
  },
  {
    label: "Confirmare locatie",
  },
  {
    label: "Asistare la receptie marfa",
  },
];

function AddUser() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [company, setCompany] = useState();
  const [clients, setClients] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [email, setEmail] = useState();
  const [restrictions, setRestrictions] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState();
  const [description, setDescription] = useState();
  const [role, setRole] = useState(["ROLE_USER"]);
  const [needsNFC, setNeedsNFC] = useState(true);

  const [allLocations, setAllLocations] = useState([]);
  const [companies, setCompanies] = useState([]);

  const [loadingAllLocations, setLoadingAllLocations] = useState(false);

  const [loadingClients, setLoadingClients] = useState(false);
  const [possibleClients, setPossibleClients] = useState([]);

  const handleChangeRestrictedActivityType = (value, index) => {
    const updatedRestrictions = [...restrictions];
    updatedRestrictions[index].activityTypes = value;
    setRestrictions(updatedRestrictions);
  };

  const handleAddRestriction = () => {
    setRestrictions([...restrictions, { locationId: "", activityTypes: [] }]);
  };

  const handleDeleteRestriction = (index) => {
    const updatedRestrictions = [...restrictions];
    updatedRestrictions.splice(index, 1);
    setRestrictions(updatedRestrictions);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "User added successfully",
    });
  };
  const error = (e) => {
    messageApi.open({
      type: "error",
      content: `User was not added. Please try again later. (${e})`,
    });
  };

  const availableLocations = locations.map((location) => {
    return {
      label: location.locationName,
      value: location.id,
    };
  });

  const getLocationsByClient = async (clients) => {
    const myArray = [];
    for (const client of clients) {
      const token = localStorage.getItem("token");
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL +
            `location/getAllLocationsByClient?client=${client}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);
        myArray.push(...response.data);
        console.log("myArray: ", myArray);
        setLocations(myArray);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getCompanies = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "company/getAllCompanies",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setCompanies(response.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleChange2 = useCallback(
  //   (item) => {
  //     setClients(item);
  //     setLocations([]);
  //     console.log(item);
  //
  //     getLocationsByClient(item);
  //   },
  //
  //   [locations, clients]
  // );

  const handleChange4 = (item) => {
    setCompany(item);
    console.log(item);
  };

  const handleChange3 = (item) => setSelectedLocations(item);

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const addUser = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");
    if (
      username &&
      password &&
      confirmPassword &&
      role &&
      company &&
      clients &&
      selectedLocations &&
      email
    ) {
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "user/addUser",
          {
            id: uuidv4(),
            email: email,
            username: username,
            password: password,
            roles: role,
            company: company,
            clients: clients,
            locationList: selectedLocations,
            restrictions: restrictions,
            phoneNumber: phoneNumber,
            description: description,
            needsNFC: needsNFC,
            avatar: "avatar",
            active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log("response.data: ", response.data);
        if (response?.data?.reason === "emailExists") {
          error("Error: Email already exists!");
        } else {
          success();
        }
      } catch (e) {
        console.log(e);
        error(e.response.data.reason);
      }
    }
  };

  const initialLocations = locations.filter((o1) =>
    selectedLocations?.some((o2) => o1.id === o2)
  );

  const addItem = (newItem) => {
    setClients([...clients, newItem]);
  };

  // Step 3: Function to remove an item from the array
  const removeItem = (itemToRemove) => {
    setClients(clients.filter((item) => item !== itemToRemove));

    setSelectedLocations((prevSelectedLocations) =>
      prevSelectedLocations.filter((locationID) => {
        const location = allLocations.find((loc) => loc.id === locationID);
        return location.client !== itemToRemove;
      })
    );
  };

  const addItem3 = (newItem) => {
    setSelectedLocations([...selectedLocations, newItem]);
  };

  // Step 3: Function to remove an item from the array
  const removeItem3 = (itemToRemove) => {
    setSelectedLocations(
      selectedLocations.filter((item) => item !== itemToRemove)
    );
  };

  const handleCheckboxChange2 = (event, item) => {
    if (event.target.checked) {
      // Checkbox is checked, add the item
      addItem(item);
    } else {
      // Checkbox is unchecked, remove the item
      removeItem(item);
    }
  };

  const handleCheckboxChange3 = (locationId) => {
    setSelectedLocations((prevSelectedLocations) => {
      // Check if the locationId is already in the selectedLocations array
      const isSelected = prevSelectedLocations.includes(locationId);

      // If it's selected, remove it; if it's not selected, add it
      if (isSelected) {
        return prevSelectedLocations.filter((id) => id !== locationId);
      } else {
        return [...prevSelectedLocations, locationId];
      }
    });
  };

  const getLocations = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingAllLocations(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "location/getAllLocations",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setAllLocations(response?.data);
      setLoadingAllLocations(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getClients = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingClients(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "clients/getAllClients",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setPossibleClients(response.data);
      setLoadingClients(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    getCompanies();
    getLocations();
  }, []);

  return (
    <>
      {contextHolder}

      <Card
        bordered={false}
        className="header-solid mb-24"
        title={
          <>
            <h6 className="font-semibold">Add User</h6>
            <p>Add user information below</p>
          </>
        }
      >
        <Row
          style={{
            marginLeft: "20px",
            marginRight: "20px",
          }}
        >
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            onFinish={onFinish}
            style={{
              width: "80%",
            }}
            scrollToFirstError
          >
            <Form.Item
              name="username"
              label="Username"
              tooltip="Please provide an username"
              rules={[
                {
                  required: true,
                  message: "Please input the username!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Please input the user password!",
                },
              ]}
              hasFeedback
            >
              <Input.Password
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              name="confirm"
              label="Confirm Password"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please confirm the user password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Item>

            {/*<Form.Item*/}
            {/*  name="company"*/}
            {/*  label="Company"*/}
            {/*  tooltip="Please provide a company name"*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: true,*/}
            {/*      message: "Please input the company name!",*/}
            {/*      whitespace: true,*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Input*/}
            {/*    value={company}*/}
            {/*    onChange={(e) => setCompany(e.target.value)}*/}
            {/*  />*/}
            {/*</Form.Item>*/}

            <Form.Item
              name="company"
              label="Company"
              tooltip="Please specify a company"
              rules={[
                {
                  required: company ? null : true,
                  message: "Please input the company!",
                  whitespace: true,
                },
              ]}
            >
              <Space
                style={{
                  width: "100%",
                }}
                direction="vertical"
              >
                <Select
                  mode="single"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Please select"
                  // defaultValue={clients}
                  onChange={handleChange4}
                  options={companies.map((company) => {
                    return {
                      label: company.companyName,
                      value: company.id,
                    };
                  })}
                />
              </Space>
            </Form.Item>

            <Form.Item
              name="clients"
              label="Clients"
              tooltip="Please specify at least one client"
              rules={[
                {
                  required: false,
                  message: "Please input the clients!",
                  whitespace: true,
                },
              ]}
            >
              <Space
                style={{
                  width: "100%",
                }}
                direction="vertical"
              >
                {/*<Select*/}
                {/*  mode="multiple"*/}
                {/*  style={{*/}
                {/*    width: "100%",*/}
                {/*  }}*/}
                {/*  placeholder="Please select"*/}
                {/*  // defaultValue={clients}*/}
                {/*  onChange={handleChange2}*/}
                {/*  options={options}*/}
                {/*/>*/}
                {possibleClients.map((option) => (
                  <Checkbox
                    checked={clients?.includes(option?.name)}
                    onChange={(e) => handleCheckboxChange2(e, option?.name)}
                  >
                    {option.name}
                  </Checkbox>
                ))}
              </Space>
            </Form.Item>

            <Form.Item
              name="locations"
              label="Locations"
              tooltip="Please specify at least one location"
              rules={[
                {
                  required: false,
                  message: "Please input the locations!",
                  whitespace: true,
                },
              ]}
            >
              <Space
                style={{
                  width: "100%",
                }}
                direction="vertical"
              >
                {loading ? (
                  <Spinner height="auto" size="default" />
                ) : (
                  allLocations.map((location) => (
                    <Checkbox
                      checked={selectedLocations.includes(location.id)}
                      onChange={() => handleCheckboxChange3(location.id)}
                      disabled={!clients.includes(location?.client)}
                    >
                      {location?.locationName}
                    </Checkbox>
                  ))
                )}
              </Space>
            </Form.Item>

            <Form.Item
              name="email"
              label="E-mail"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
              ]}
            >
              <Input value={email} onChange={(e) => setEmail(e.target.value)} />
            </Form.Item>

            <Form.Item name="phone" label="Phone Number">
              <Input
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>

            <Form.Item
              name="intro"
              label="Description"
              rules={[
                {
                  required: false,
                  message: "Please input Description",
                },
              ]}
            >
              <Input.TextArea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                showCount
                maxLength={100}
              />
            </Form.Item>

            <Form.Item
              name="role"
              label="Role"
              initialValue="User"
              rules={[
                {
                  required: true,
                  message: "Please select role!",
                },
              ]}
            >
              <Select
                defaultValue="ROLE_USER"
                placeholder="Select the role"
                value={role}
                options={[
                  { value: "ROLE_USER", label: "User" },
                  { value: "ROLE_ADMIN", label: "Admin" },
                ]}
                onChange={(value) => setRole([value])}
              />
            </Form.Item>

            <Form.Item label="Needs NFC" initialValue={needsNFC}>
              <CustomSwitch
                checked={needsNFC}
                onChange={(e) => setNeedsNFC(e)}
              />
            </Form.Item>

            {/*RESTRICTIONS*/}
            <div>
              <Form.Item {...tailFormItemLayout}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "16px",
                  }}
                >
                  {/*<p>Restrictions:</p>*/}
                  <Button onClick={handleAddRestriction}>
                    Add Restriction
                  </Button>
                </div>
              </Form.Item>
              {restrictions?.map((restriction, index) => (
                <div key={index}>
                  <Form.Item
                    label={`Restriction Location ${index + 1}`}
                    initialValue={restriction.locationId}
                  >
                    <Select
                      showSearch
                      placeholder="Select the restriction location"
                      optionFilterProp="children"
                      value={restriction.locationId}
                      onChange={(value) => {
                        const updatedRestrictions = [...restrictions];
                        updatedRestrictions[index].locationId = value;
                        setRestrictions(updatedRestrictions);
                      }}
                    >
                      {allLocations?.map((location) => (
                        <Option
                          key={location.id}
                          value={location.id}
                          label={location.locationName}
                        >
                          {location.locationName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label={`Restricted Activity Types ${index + 1}`}
                    initialValue={restriction.activityTypes}
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      placeholder="Select restricted activity types"
                      optionFilterProp="children"
                      style={{ width: "100%" }}
                      value={restriction.activityTypes}
                      onChange={(value) =>
                        handleChangeRestrictedActivityType(value, index)
                      }
                    >
                      {possibleActvityTypes.map((activity) => (
                        <Option key={activity.label} value={activity.label}>
                          {activity.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: "16px",
                    }}
                  >
                    <span
                      style={{
                        color: "red",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => handleDeleteRestriction(index)}
                    >
                      Delete Restriction
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <Form.Item {...tailFormItemLayout}>
              <Button
                type="secondary"
                className="tag-primary"
                htmlType="submit"
                onClick={() => addUser()}
              >
                Create User
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Card>
    </>
  );
}

export default AddUser;
